import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/pro-duotone-svg-icons';

import { IClinic } from '@customTypes/clinician';

interface IProps {
  clinics: IClinic[];
  selectedOrganization: IClinic | null;
  onSelect: (clinic: IClinic) => void;
}

export default function OrganizationHeader({ clinics, selectedOrganization, onSelect }: IProps) {
  return (
    <div className='d-flex align-items-center mb-3 organization-header'>
      <h2 className='mb-0 d-flex align-items-center gap-2'>
        <FontAwesomeIcon icon={faBuilding} className='organization-icon' />
        <span className='organization-label'>Organization:</span>
        {clinics.length > 1 ? (
          <Dropdown>
            <Dropdown.Toggle variant='outline-primary' size='lg' className='fw-bold'>
              {selectedOrganization?.name}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {clinics.map(clinic => (
                <Dropdown.Item
                  key={clinic.clinic_id}
                  onClick={() => onSelect(clinic)}
                  active={selectedOrganization?.clinic_id === clinic.clinic_id}
                >
                  {clinic.name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <div className='fw-bold'>
            <span>{selectedOrganization?.name}</span>
          </div>
        )}
      </h2>
    </div>
  );
}
